import Vue from "vue";

export function postAction(url, param) {
    return Vue.prototype.$EdFrame.request({
        url: url,
        method: 'post',
        data: param
    })
}

export function getAction(url, param) {
    return Vue.prototype.$EdFrame.request({
        url: url,
        method: 'get',
        params: param
    })
}

export function deleteAction(url, param) {
    return Vue.prototype.$EdFrame.request({
        url: url,
        method: 'delete',
        params: param,
    })
}

export function putAction(url, param) {
    return Vue.prototype.$EdFrame.request({
        url: url,
        method: 'put',
        data: param,
    })
}

export function uploadAction(url, param) {
    return Vue.prototype.$EdFrame.request({
        url: url,
        data: param,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
}

export function downFilePost(url, parameter) {
    return Vue.prototype.$EdFrame.request({
        url: url,
        data: parameter,
        method: 'post',
        responseType: 'blob'
    })
}

export default {
    postAction,
    getAction,
    deleteAction,
    putAction,
    uploadAction,
}
